var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconResidencia = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 40 40",
  style: {
    enableBackground: "new 0 0 40 40"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M38.5,12.8L21.4,3c-0.9-0.5-2-0.5-2.9,0L1.5,12.8c-1.4,0.8-1.9,2.6-1.1,4c0.5,0.9,1.5,1.5,2.5,1.5 c0.5,0,1-0.1,1.4-0.4l0.8-0.4v18.8c0,0.7,0.6,1.3,1.3,1.3h2.5c0.7,0,1.3-0.6,1.3-1.3v-10c0-0.7,0.6-1.5,1.3-1.5H17 c0.7,0,1.3,0.8,1.3,1.5v10c0,0.7,0.6,1.3,1.3,1.3h14c0.7,0,1.3-0.6,1.3-1.3V17.4l0.8,0.4c1.4,0.8,3.2,0.3,4-1.1 C40.4,15.4,39.9,13.6,38.5,12.8z M30.5,25.6c0,0.7-0.6,1.3-1.3,1.3h-5.5c-0.7,0-1.3-0.6-1.3-1.3V20c0-0.7,0.6-1.3,1.3-1.3h5.5 c0.7,0,1.3,0.6,1.3,1.3V25.6z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconResidencia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_residencia.584e75a0.svg";
export { ForwardRef as ReactComponent };